import { createApiCall } from 'lib/base';

const REGISTER_INTEREST_SUBSCRIPTION_USER = 'REGISTER_INTEREST_SUBSCRIPTION_USER';

const registerInterestApi = createApiCall<{
  id: string;
  userId: string;
  optionId: string;
}>(REGISTER_INTEREST_SUBSCRIPTION_USER, ({ id, userId, optionId }) => ({
  endpoint: `api/admin/subscriptions/${id}/users/${userId}/options/${optionId}/register-interest`,
  method: 'POST',
}));

export default registerInterestApi;
